import {
  BOOST_PRODUCTS_USER_SORT,
  MAX_PRODUCTS_USER_SORT,
} from '@tiendanube/common/src/domains/online/constants';
import { CATALOG_EXTRA_SORT_LIMIT } from 'App/featuresFlags';
import { useGetTags } from 'domains/Auth/hooks';

function useGetMaxProductSort() {
  const tags = useGetTags();
  const hasExtraSortLimit = tags.includes(CATALOG_EXTRA_SORT_LIMIT);
  return hasExtraSortLimit ? BOOST_PRODUCTS_USER_SORT : MAX_PRODUCTS_USER_SORT;
}

export default useGetMaxProductSort;
